import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { Link } from 'react-router-dom';

const MinhasListas = () => {
  const [listas, setListas] = useState([]);
  const [nomeLista, setNomeLista] = useState('');
  const { authData } = useContext(AuthContext);
  const { token } = authData;

  const [editingId, setEditingId] = useState(null);
  const [editingName, setEditingName] = useState('');

  const [sharingId, setSharingId] = useState(null);
  const [sharingEmail, setSharingEmail] = useState('');

  useEffect(() => {
    if (!token) {
      alert('Você precisa estar logado para acessar esta página.');
      window.location.href = '/login';
    } else {
      fetchListas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const fetchListas = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/listas`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setListas(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const criarLista = async () => {
    if (nomeLista.trim() === '') {
      alert('O nome da lista não pode estar vazio.');
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/listas`,
        { nome: nomeLista },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setNomeLista('');
      fetchListas();
    } catch (err) {
      console.error(err);
    }
  };

  const deletarLista = async (id) => {
    if (window.confirm('Você tem certeza que deseja deletar esta lista?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/listas/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        fetchListas();
      } catch (err) {
        console.error(err.response ? err.response.data : err.message);
      }
    }
  };

  const updateNameLista = async (id, newName) => {
    if (!newName.trim()) {
      alert('O nome da lista não pode estar vazio.');
      return;
    }
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/listas/${id}`,
        { nome: newName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setEditingId(null);
      setEditingName('');
      fetchListas();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditClick = (lista) => {
    setEditingId(lista._id);
    setEditingName(lista.nome);
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setEditingName('');
  };

  const handleShareClick = (lista) => {
    setSharingId(lista._id);
  };

  const handleCancelShare = () => {
    setSharingId(null);
    setSharingEmail('');
  };

  const handleShare = async () => {
    if (!sharingEmail.trim()) {
      alert('O email não pode estar vazio.');
      return;
    }
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/listas/${sharingId}/share`,
        { email: sharingEmail },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert('Lista compartilhada com sucesso!');
      handleCancelShare();
    } catch (err) {
      alert(err.response.data.msg || 'Erro ao compartilhar a lista.');
      console.error(err);
    }
  };

  return (
    <div>
      <h2>Minhas Listas</h2>

      <div className="mb-3 row">
        <div className="col-12 col-md-9 mb-2 mb-md-0">
          <input
            type="text"
            placeholder="Nome da Nova Lista"
            value={nomeLista}
            onChange={(e) => setNomeLista(e.target.value)}
            className="form-control"
            onKeyDown={(e) => e.key === 'Enter' && criarLista()}
          />
        </div>
        <div className="col-12 col-md-3">
          <button className="btn btn-primary w-100" onClick={criarLista}>
            Criar Lista
          </button>
        </div>
      </div>

      <ul className="list-group">
        {listas.map((lista) => {
          if (editingId === lista._id) {
            return (
              <li key={lista._id} className="list-group-item d-flex flex-column flex-md-row align-items-center">
                <input
                  type="text"
                  value={editingName}
                  onChange={(e) => setEditingName(e.target.value)}
                  className="form-control me-md-2 mb-2 mb-md-0"
                  onKeyDown={(e) => e.key === 'Enter' && updateNameLista(lista._id, editingName)}
                />
                <div className="d-flex flex-wrap justify-content-end">
                  <button
                    className="btn btn-success me-2 mb-2 mb-md-0"
                    onClick={() => updateNameLista(lista._id, editingName)}
                  >
                    Salvar
                  </button>
                  <button className="btn btn-secondary mb-2 mb-md-0" onClick={handleCancelEdit}>
                    Cancelar
                  </button>
                </div>
              </li>
            );
          } else if (sharingId === lista._id) {
            return (
              <li key={lista._id} className="list-group-item d-flex flex-column flex-md-row align-items-center">
                <input
                  type="email"
                  placeholder="Email do usuário"
                  value={sharingEmail}
                  onChange={(e) => setSharingEmail(e.target.value)}
                  className="form-control me-md-2 mb-2 mb-md-0"
                  onKeyDown={(e) => e.key === 'Enter' && handleShare()}
                />
                <div className="d-flex flex-wrap justify-content-end">
                  <button className="btn btn-success me-2 mb-2 mb-md-0" onClick={handleShare}>
                    Compartilhar
                  </button>
                  <button className="btn btn-secondary mb-2 mb-md-0" onClick={handleCancelShare}>
                    Cancelar
                  </button>
                </div>
              </li>
            );
          } else {
            return (
              <li
                key={lista._id}
                className="list-group-item d-flex flex-column flex-md-row justify-content-between align-items-md-center"
              >
                <Link to={`/lista/${lista._id}`} className="mb-2 mb-md-0">{lista.nome}</Link>

                <div className="d-flex flex-wrap justify-content-end">
                  <button
                    className="btn btn-info me-2 mb-2 mb-md-0"
                    onClick={() => handleShareClick(lista)}
                  >
                    <i className="bi bi-share"></i>
                  </button>
                  <button
                    className="btn btn-info me-2 mb-2 mb-md-0"
                    onClick={() => handleEditClick(lista)}
                  >
                    <i className="bi bi-pencil"></i>
                  </button>
                  <button
                    className="btn btn-danger mb-2 mb-md-0"
                    onClick={() => deletarLista(lista._id)}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                </div>
              </li>
            );
          }
        })}
      </ul>
    </div>
  );
};

export default MinhasListas;